export function setDailyCreate(payload) {
  return {
    type: 'DAILY_CREATE',
    payload: payload,
  };
}

export function setDailyJoin(payload) {
  return {
    type: 'DAILY_JOIN',
    payload: payload,
  };
}

export function setDailyManage(payload) {
  return {
    type: 'DAILY_MANAGE',
    payload: payload,
  };
}

export function setActivityCreate(payload) {
  return {
    type: 'ACTIVITY_CREATE',
    payload: payload,
  };
}

export function setActivityJoin(payload) {
  return {
    type: 'ACTIVITY_JOIN',
    payload: payload,
  };
}

export function setActivityManage(payload) {
  return {
    type: 'ACTIVITY_MANAGE',
    payload: payload,
  };
}

export function setAllActivities(payload) {
  return {
    type: 'ALL_ACTIVITIES',
    payload: payload,
  };
}

let initialState = {
  dailyCreate: {},
  dailyJoin: {},
  dailyManage: {},
  activityCreate: {},
  activityJoin: {},
  activityManage: {},
  allActivities: {},
};

export default function zongcuFormInfo(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case 'DAILY_CREATE':
      return Object.assign({}, state, { dailyCreate: payload });
    case 'DAILY_JOIN':
      return Object.assign({}, state, { dailyJoin: payload });
    case 'DAILY_MANAGE':
      return Object.assign({}, state, { dailyManage: payload });
    case 'ACTIVITY_CREATE':
      return Object.assign({}, state, { activityCreate: payload });
    case 'ACTIVITY_JOIN':
      return Object.assign({}, state, { activityJoin: payload });
    case 'ACTIVITY_MANAGE':
      return Object.assign({}, state, { activityManage: payload });
    case 'ALL_ACTIVITIES':
      return Object.assign({}, state, { allActivities: payload });
    default:
      return state;
  }
}
